import { Link } from 'react-router-dom';

import { pergolas } from "../../../../datas/pergolas"
import { useParams , useLocation} from "react-router-dom";
import { MdDownloadForOffline } from "react-icons/md";
import { getPdfUrl } from "../../../../utils/pdf";
import { MdBlindsClosed } from "react-icons/md";
import { LuPanelsLeftBottom } from "react-icons/lu";
import { MdGrid4X4 } from "react-icons/md";
import { MdOutlineVerticalShadesClosed } from "react-icons/md";
import { RiLightbulbFlashFill } from "react-icons/ri";
import { MdColorLens } from "react-icons/md";

function Pergolas() {
    const { pergolasType } = useParams();
    const pergolaContentType = pergolas[pergolasType];
    const { pathname } = useLocation();

    if (!pergolaContentType) return <p>Type de pergola introuvable {pergolasType}</p>

    return (
        <div key={pathname} className="flex flex-col gap-4 lg:gap-8 xl:gap-12 min-h-[70vh] py-[5vh] xl:py-[10vh] 2xl:py[15vh] px-[5vw] xl:px-[8vw] opacity-0 animate-zoom-in">
            <div className='flex flex-col gap-6 md:gap-10 xl-gap-14'>
                <h1 className=" text-center xl:pb-6 text-xl sm:text-2xl md:text-4xl lg:text-6xl xl:text-6xl 2xl:text-8xl font-bold">{pergolaContentType.titre}</h1>
                <div className=''>
                    <p className="p-6 md:p-10 xl:p-16 text-justify border-y border-brun-contrast/50">
                        {pergolaContentType.intro}
                    </p>
                </div>
            </div>
            <div className='flex flex-col gap-[10vh] xl:gap-[14vh] 2xl:gap-[16vh] py-10 xl:py-20'>
                {pergolaContentType.items.map((item, index) => 
                <div key={index} className="flex flex-col lg:flex-row gap-2 md:gap-4 xl-gap-8 bg-white rounded text-brun-dark/80">
                    <div className="w-full lg:w-1/3 py-4 md:py-6 flex flex-col items-center justify-around">
                        <h2 className="font-semibold uppercase text-center">{item.titre}</h2>
                        <div className="w-full h-[250px] md:h-[300px] xl:h-[350px] flex items-center justify-center">
                            <img src={item.image} alt={item.titre} className='max-h-full max-w-full object-contain rounded'></img>
                        </div>
                    </div>
                    <div className="w-full lg:w-2/3 py-4 md:py-6 flex flex-col gap-4 md:gap-6 xl:gap-10 px-4 text-justify bg-brun-contrast/10">
                        <div className="flex flex-1 flex-col justify-between gap-4 md:gap-6 xl:gap-10 pb-6 border-b-2 border-brun-contrast/50 max-h-[300px] md:max-h-[350px] xl:max-h-[400px] overflow-auto pr-2">
                            <h4 className="font-semibold text-center text-brun-contrast">{item.intro}</h4>
                            <div className="px-6">{item.presentation}</div>
                            {/* Coorriger list */}
                            {item.disponibilites && (
                                <ul className=" px-8 italic list-disc list-inside">
                                    {item.disponibilites.map((carac, index) => (
                                        <li className="list-none" key={index}>{carac}</li>
                                    ))}
                                </ul>                
                            )}
                            <div className="px-6">{item.conclusion}</div>
                            {/* <div className=" px-6 ">{item.infos}</div> */}
                        </div>
                        <div className="flex flex-col md:flex-row gap-4 md:gap-6 xl:gap-10 items-center md:items-start w-full">
                            <div className="w-full md:w-1/2 flex justify-center md:justify-start xl:justify-center">
                                {item.logo && (
                                    <img src={item.logo} alt="Logo de la marque" className="max-w-[200px] md:max-w-[250px]"></img>
                                )}
                            </div>
                            <div className="w-full md:w-1/2 flex flex-col items-center md:items-end gap-4 xl:justify-center">
                                <div className="w-full text-end font-semibold text-brun-contrast">{item.prix}</div>
                                {item.fiche && (
                                    // download a rajouter si custom domain et domain same [A tester]
                                    <a className="p-4 w-full flex items-center justify-center gap-4 rounded-md bg-brun-contrast text-white hover:bg-brun-main transition duration:300" href={getPdfUrl(item.fiche)} target="_blank" rel="noopener noreferrer">
                                        Télécharger la fiche Produit <MdDownloadForOffline/>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
            <div className='flex flex-col gap-6 md:gap-10 xl-gap-14'>
                <h2 className=" text-center xl:py-6 text-xl md:text-2xl lg:text-4xl 2xl:text-6xlxl font-bold">Personnalisez votre pergola</h2>
                <div className='gap-2 lg:gap-4 2xl:gap-8'>
                    <div className='flex flex-col gap-10 p-6 md:p-10 xl:p-16 text-center border-y border-brun-contrast/50'>
                        <p>Pour transformer votre pergola en véritable pièce extérieure, plusieurs équipements peuvent être intégrés :</p>
                        <div>
                            <div className='p-2 lg:p-4 2xl:p-6'>
                                <div className='flex gap-2 md:gap-4 xl-gap-8 items-center justify-center text-brun-contrast font-bold'>
                                    <MdBlindsClosed />
                                    <h2>Stores Zip Screen</h2>
                                </div>
                                <p className=''>Stores latéraux motorisés permettant de se protéger du soleil, du vent et du vis-à-vis.</p>
                            </div>
                            <div className='p-2 lg:p-4 2xl:p-6'>
                                <div className='flex gap-2 md:gap-4 xl-gap-8 items-center justify-center text-brun-contrast font-bold'>
                                    <LuPanelsLeftBottom />
                                    <h2>Vitrages coulissants</h2>
                                </div>
                                <p>Parois vitrées coulissantes permettant de fermer la pergola tout en conservant une vue dégagée.</p>
                            </div>
                            <div className='p-2 lg:p-4 2xl:p-6'>
                                <div className='flex gap-2 md:gap-4 xl-gap-8 items-center justify-center text-brun-contrast font-bold'>
                                    <MdGrid4X4 />
                                    <h2>Claustra aluminium</h2>
                                </div>
                                <p>Panneaux décoratifs à lames fixes pour apporter intimité et design architectural.</p>
                            </div>
                            <div className='p-2 lg:p-4 2xl:p-6'>
                                <div className='flex gap-2 md:gap-4 xl-gap-8 items-center justify-center text-brun-contrast font-bold'>
                                <MdOutlineVerticalShadesClosed />
                                <h2>Volets coulissants</h2>
                                </div>
                                <p>Solution élégante pour moduler l’ombre et se protéger du vis-à-vis.</p>
                            </div>
                            <div className='p-2 lg:p-4 2xl:p-6'>
                                <div className='flex gap-2 md:gap-4 xl-gap-8 items-center justify-center text-brun-contrast font-bold'>
                                    <RiLightbulbFlashFill />
                                    <h2>Éclairage LED intégré</h2>
                                </div>
                                <p>Éclairage discret intégré à la structure pour profiter de votre terrasse en soirée.</p>
                            </div>
                            <div className='p-2 lg:p-4 2xl:p-6'>
                                <div className='flex gap-2 md:gap-4 xl-gap-8 items-center justify-center text-brun-contrast font-bold'>
                                    <MdColorLens />
                                    <h2>Coloris</h2>
                                </div>
                                <p>Large choix de couleurs RAL.</p>
                            </div>
                        </div>
                    </div>
                    {/* <p className="p-6 md:p-10 xl:p-16 text-justify border-y border-brun-contrast/50">
                        Pour transformer votre pergola en véritable pièce extérieure, plusieurs équipements peuvent être intégrés.
                    </p> */}
                </div>
            </div>
            <div className='flex flex-col gap-6 md:gap-10 xl-gap-14'>
                <h2 className=" text-center xl:py-6 text-xl md:text-2xl lg:text-4xl 2xl:text-6xlxl font-bold">Demandez votre étude personnalisée</h2>
                <div className='gap-2 lg:gap-4 2xl:gap-8'>
                    <div className="flex flex-col p-6 md:p-10 xl:p-16 gap-6 text-center items-center border-t border-brun-contrast/50">
                        <div>
                            <p>Vous avez un projet de pergola pour votre terrasse ou votre jardin ?</p>
                            <p>Nos équipes vous accompagnent pour définir la solution la plus adaptée à votre espace et à votre budget.</p>
                        </div>
                        <Link to='/devis/' className="lg:w-[50%] w-full mt-6 py-2 lg:py-4 2xl:py-6 rounded-full bg-brun-main text-beige hover:bg-brun-contrast hover:text-brun-dark transition duration:300 text-center sm:text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">Obtenir un devis gratuit</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Pergolas;